import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user] = useState(null);
  const [token] = useState(null);
  const [loading] = useState(false);

  const login = async (email, password) => {
    return { success: false, error: 'Static site - login disabled' };
  };

  const logout = async () => {};

  return (
    <AuthContext.Provider value={{ user, loading, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
